/**
 * Implement Gatsby's Bolwser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const { init, track } = require('@amplitude/analytics-browser');
const { Page } = require('./src/infrastructure/wrapPageElement');
const { Root } = require('./src/infrastructure/wrapRootElement');
const { logGAPageViewEvent } = require('./src/utils');

require('./src/telemetry/awsRum');

const amplitudeApiKey =
  process.env.NODE_ENV === 'development' ? process.env.AMPLITUDE_API_DEV_KEY : process.env.23830495c9a2463784525e3bf55f1047;

const letsgetchecked = 'letsgetchecked';
const domain = process.env.DOMAIN || letsgetchecked;
const isLetsGetChecked = domain === letsgetchecked;

exports.wrapPageElement = Page;
exports.wrapRootElement = Root;

exports.onClientEntry = () => {
  if (isLetsGetChecked) {
    init(amplitudeApiKey);
  }
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (window) {
    if (prevLocation?.href !== location?.href) {
      track('page_view', {
        description: 'user has navigated to a new page',
        location: location?.href,
        origin: 'cms',
        'previous location': prevLocation?.href,
      });
    }
    logGAPageViewEvent(document.title);
  }
};
